export const MSG_CATEGORY_YOU = 'YOU'
export const MSG_CATEGORY_UNASSIGNED = 'UNASSIGNED'
export const MSG_CATEGORY_ALL = 'ALL'
export const MSG_CATEGORY_TAGS = 'TAGS'
export const MSG_CATEGORY_ARCHIVE = 'ARCHIVE'

export const inboxSidebarFilters = Object.freeze({
    you: {
        key: MSG_CATEGORY_YOU,
        title: 'You',
        icon: 'far fa-user'
    },
    unassigned: {
        key: MSG_CATEGORY_UNASSIGNED,
        title: 'Unassigned',
        icon: 'far fa-user-times'
    },
    all: {
        key: MSG_CATEGORY_ALL,
        title: 'All',
        icon: 'far fa-user-friends'
    },
    tags: {
        key: MSG_CATEGORY_TAGS,
        title: 'Tags',
        icon: 'far fa-tag'
    },
    archive: {
        key: MSG_CATEGORY_ARCHIVE,
        title: 'Archive',
        icon: 'far fa-archive'
    }
})

export const inboxSidebarFiltersList = Object.freeze(Object.values(inboxSidebarFilters))
